module.exports = __webpack_public_path__ + "static/img/a15.a42c772.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/a15.jpg
// module id = 433
// module chunks = 1